module.exports = __webpack_public_path__ + "static/05-4316ca32d247dded0c745e6178f885c0.jpg";